export default "__VITE_ASSET__a83d97aa__"